import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Phone, Mail, MapPin, Clock, Send } from 'lucide-react';
import { Button } from '../components/Button';
export function ContactPage() {
  return <div className="w-full" data-id="element-282">
      {/* Hero */}
      <section className="py-16 md:py-20 bg-background px-6" data-id="element-283">
        <div className="max-w-7xl mx-auto text-center" data-id="element-284">
          <h1 className="text-4xl md:text-5xl font-display font-bold text-charcoal mb-4 md:mb-6" data-id="element-285">
            Contact Us
          </h1>
          <p className="text-lg md:text-xl text-muted max-w-2xl mx-auto" data-id="element-286">
            We're here to help you find the right housing solution. Reach out to
            us today.
          </p>
        </div>
      </section>

      <section className="py-12 md:py-20 px-6" data-id="element-287">
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 md:gap-20" data-id="element-288">
          {/* Contact Info */}
          <div className="space-y-8 md:space-y-12" data-id="element-289">
            <div className="space-y-6 md:space-y-8" data-id="element-290">
              <h2 className="text-3xl md:text-4xl font-display font-bold text-charcoal" data-id="element-291">
                Get in Touch
              </h2>
              <p className="text-lg text-muted leading-relaxed" data-id="element-292">
                Whether you have questions about our homes, need to schedule a
                tour, or want to discuss a referral, our team is ready to assist
                you.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-293">
              <div className="space-y-4" data-id="element-294">
                <div className="w-12 h-12 bg-primary/5 rounded-xl flex items-center justify-center text-primary" data-id="element-295">
                  <Phone size={24} data-id="element-296" />
                </div>
                <h4 className="text-xl font-bold text-charcoal" data-id="element-297">Phone</h4>
                <p className="text-muted" data-id="element-298">(410) 555-0123</p>
                <p className="text-xs font-bold text-accent uppercase tracking-widest" data-id="element-299">
                  Available 24/7 for Emergencies
                </p>
              </div>
              <div className="space-y-4" data-id="element-300">
                <div className="w-12 h-12 bg-primary/5 rounded-xl flex items-center justify-center text-primary" data-id="element-301">
                  <Mail size={24} data-id="element-302" />
                </div>
                <h4 className="text-xl font-bold text-charcoal" data-id="element-303">Email</h4>
                <p className="text-muted" data-id="element-304">info@birdsnestliving.com</p>
                <p className="text-muted" data-id="element-305">admissions@birdsnestliving.com</p>
              </div>
              <div className="space-y-4" data-id="element-306">
                <div className="w-12 h-12 bg-primary/5 rounded-xl flex items-center justify-center text-primary" data-id="element-307">
                  <MapPin size={24} data-id="element-308" />
                </div>
                <h4 className="text-xl font-bold text-charcoal" data-id="element-309">Office</h4>
                <p className="text-muted" data-id="element-310">
                  Serving all of Maryland with regional offices in Baltimore and
                  Silver Spring.
                </p>
              </div>
              <div className="space-y-4" data-id="element-311">
                <div className="w-12 h-12 bg-primary/5 rounded-xl flex items-center justify-center text-primary" data-id="element-312">
                  <Clock size={24} data-id="element-313" />
                </div>
                <h4 className="text-xl font-bold text-charcoal" data-id="element-314">Hours</h4>
                <p className="text-muted" data-id="element-315">Mon - Fri: 9am - 5pm</p>
                <p className="text-muted" data-id="element-316">Sat - Sun: By Appointment</p>
              </div>
            </div>
          </div>

          {/* Form */}
          <div className="bg-white p-8 md:p-12 lg:p-16 rounded-3xl shadow-2xl border border-gray-100" data-id="element-317">
            <form className="space-y-6" data-id="element-318">
              <div className="space-y-2" data-id="element-319">
                <label className="text-sm font-bold text-charcoal" data-id="element-320">
                  Full Name
                </label>
                <input type="text" className="w-full px-4 py-3 bg-gray-50 border-none rounded-xl focus:ring-2 focus:ring-primary" placeholder="Your Name" data-id="element-321" />
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-322">
                <div className="space-y-2" data-id="element-323">
                  <label className="text-sm font-bold text-charcoal" data-id="element-324">
                    Email
                  </label>
                  <input type="email" className="w-full px-4 py-3 bg-gray-50 border-none rounded-xl focus:ring-2 focus:ring-primary" placeholder="email@example.com" data-id="element-325" />
                </div>
                <div className="space-y-2" data-id="element-326">
                  <label className="text-sm font-bold text-charcoal" data-id="element-327">
                    Phone
                  </label>
                  <input type="tel" className="w-full px-4 py-3 bg-gray-50 border-none rounded-xl focus:ring-2 focus:ring-primary" placeholder="(410) 000-0000" data-id="element-328" />
                </div>
              </div>
              <div className="space-y-2" data-id="element-329">
                <label className="text-sm font-bold text-charcoal" data-id="element-330">
                  Subject
                </label>
                <select className="w-full px-4 py-3 bg-gray-50 border-none rounded-xl focus:ring-2 focus:ring-primary appearance-none" data-id="element-331">
                  <option data-id="element-332">General Inquiry</option>
                  <option data-id="element-333">Schedule a Tour</option>
                  <option data-id="element-334">Bed Availability</option>
                  <option data-id="element-335">Referral Partnership</option>
                </select>
              </div>
              <div className="space-y-2" data-id="element-336">
                <label className="text-sm font-bold text-charcoal" data-id="element-337">
                  Message
                </label>
                <textarea rows={6} className="w-full px-4 py-3 bg-gray-50 border-none rounded-xl focus:ring-2 focus:ring-primary" placeholder="How can we help you?" data-id="element-338"></textarea>
              </div>
              <Button className="w-full py-4 text-lg flex items-center justify-center space-x-2" data-id="element-339">
                <span data-id="element-340">Send Message</span>
                <Send size={18} data-id="element-341" />
              </Button>
            </form>
          </div>
        </div>
      </section>

      {/* Map */}
      <section className="py-12 md:py-20 px-6" data-id="element-342">
        <div className="max-w-7xl mx-auto h-[300px] md:h-[500px] rounded-3xl overflow-hidden shadow-xl border border-gray-100" data-id="element-343">
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d197866.92944941655!2d-76.77491048867188!3d39.28482849999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c803aed6f483b7%3A0x44896a84223e758!2sBaltimore%2C%20MD!5e0!3m2!1sen!2sus!4v1715634000000!5m2!1sen!2sus" width="100%" height="100%" style={{
          border: 0
        }} allowFullScreen loading="lazy" data-id="element-344"></iframe>
        </div>
      </section>
    </div>;
}